export const newsData = [
  {
    id: 1,
    title: "New Wellness Programs Launch at Minneopa Springs",
    excerpt:
      "Discover our latest therapeutic treatments combining traditional hot spring therapy with modern wellness practices.",
    date: "2025-05-15",
    category: "Wellness",
    image: "/images/wellness.webp",
    featured: true,
  },
  {
    id: 2,
    title: "Sustainable Practices in Minnesota Hot Springs",
    excerpt:
      "Learn how local hot springs are leading the way in environmental conservation and sustainable tourism.",
    date: "2025-05-10",
    category: "Environment",
    image: "/images/news-sustainability.webp",
    featured: true,
  },
  {
    id: 3,
    title: "Summer Events Calendar Released",
    excerpt:
      "From yoga retreats to astronomy nights, discover the exciting events happening at Mankato area hot springs this summer.",
    date: "2025-05-05",
    category: "Events",
    image: "/images/news-events.jpg",
    featured: true,
  },
  {
    id: 4,
    title: "Health Benefits of Mineral Spring Therapy",
    excerpt:
      "Recent studies highlight the therapeutic benefits of natural mineral hot springs for stress relief and muscle recovery.",
    date: "2025-04-28",
    category: "Health",
    image: "/images/health.jpg",
    featured: false,
  },
  {
    id: 5,
    title: "Local Artist Collaboration at Blue Earth Spa",
    excerpt:
      "Minnesota artists showcase their work in a unique exhibition celebrating the natural beauty of hot springs.",
    date: "2025-04-20",
    category: "Culture",
    image: "/images/art.jpg",
    featured: false,
  },
];
